
import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  setOpenProtocolOrder: ['data'],
  setOpenProtocolProducts: ['data'],
  setOpenProtocolUnselectedItems: ['data'],
  setOpenProtocolCte: ['data'],
  setOpenProtocolCteInvoice: ['data'],
  resetOpenProtocolData: [],
});

interface IOpenProtocolData {
  order?: any;
  products: any;
  cte?: Array<any>;
  cteInvoice?: Array<any>;
}

const INITIAL_STATE: IOpenProtocolData = {
  order: undefined,
  products: [],
  cte: [],
  cteInvoice: []
};

const setOpenProtocolOrder = (state = INITIAL_STATE, action: any) => ({
  ...state,
  order: { ...action.data },
});

const setOpenProtocolProducts = (state = INITIAL_STATE, action: any) => ({
  ...state,
  products: [...action.data],
});

const setOpenProtocolCte = (state = INITIAL_STATE, action: any) => ({
  ...state,
  cte: [...action.data],
});

const setOpenProtocolCteInvoice = (state = INITIAL_STATE, action: any) => ({
  ...state,
  cteInvoice: [...action.data],
});

const resetOpenProtocolData = () => ({
  order: undefined,
  products: [],
  cte: [],
  cteInvoice: []
});

export default createReducer(INITIAL_STATE, {
  [Types.SET_OPEN_PROTOCOL_ORDER as any]: setOpenProtocolOrder,
  [Types.SET_OPEN_PROTOCOL_PRODUCTS as any]: setOpenProtocolProducts,
  [Types.SET_OPEN_PROTOCOL_CTE as any]: setOpenProtocolCte,
  [Types.SET_OPEN_PROTOCOL_CTE_INVOICE as any]: setOpenProtocolCteInvoice,
  [Types.RESET_OPEN_PROTOCOL_DATA as any]: resetOpenProtocolData,
});
